
export default{
    init(){

        var post=function (data) {         // datat应为'a=a1&b=b1'这种字符串格式，在jq里如果data为对象会自动将对象转成这种字符串格式
                var obj = new XMLHttpRequest();
                obj.open("POST", data.url, true);
                obj.setRequestHeader("Content-type", "application/x-www-form-urlencoded");  // 添加http头，发送信息至服务器时内容编码类型
                obj.onreadystatechange = function() {
                    if (obj.readyState == 4 && (obj.status == 200 || obj.status == 304)) {  // 304未修改
                        data.success(obj.responseText);
                    }
                };
                obj.send(data.data);
            }
        var data = {
            isteyes: true,
            type: 'share',
            url: window.location.href.split('#')[0]
        };
        data = JSON.stringify(data);
        post({
            url: 'http://t6.teyes.cn/api/jssdk.php',
            data: data,
            type: 'post',
            success: function(data) {
                var data = JSON.parse(data);
                // data.debug=true
                data.jsApiList = [
                    'checkJsApi',
                    'onMenuShareTimeline',
                    'onMenuShareAppMessage',
                    'onMenuShareQQ',
                    'onMenuShareWeibo',
                    'onMenuShareQZone',
                    'hideMenuItems',
                    'showMenuItems',
                    'hideAllNonBaseMenuItem',
                    'showAllNonBaseMenuItem',
                    'translateVoice',
                    'startRecord',
                    'stopRecord',
                    'onVoiceRecordEnd',
                    'playVoice',
                    'onVoicePlayEnd',
                    'pauseVoice',
                    'stopVoice',
                    'uploadVoice',
                    'downloadVoice',
                    'chooseImage',
                    'previewImage',
                    'uploadImage',
                    'downloadImage',
                    'getNetworkType',
                    'openLocation',
                    'getLocation',
                    'hideOptionMenu',
                    'showOptionMenu',
                    'closeWindow',
                    'scanQRCode',
                    'chooseWXPay',
                    'openProductSpecificView',
                    'addCard',
                    'chooseCard',
                    'openCard'
                ]
                wx.config(data);
                wx.ready(function() {

                    var message ={
                        title: '天之眼【核心4G智能大屏车机 MAX CC】', // 分享标题
                        desc: '本站点提供天之眼MAX CC智能车机使用帮助，不断更新中', // 分享描述
                        link: 'http://cc.teyes.cn', // 分享链接
                        imgUrl: 'http://cc.teyes.cn/show.jpg', // 分享图标
                    }

                    wx.onMenuShareAppMessage(message);
                    wx.onMenuShareTimeline(message);
                })
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/ws.js